<template>
	<ja-modal :show="show" class="confirm-modal">
		<ja-close-button
			name="close"
			@click.native="closeModal()"
		></ja-close-button>
		<div class="modal-content">
			<h3 class="heading-3">{{ title }}</h3>
			<p class="content">
				<slot></slot>
			</p>
		</div>

		<div class="btn-group btn-group--center">
			<ja-button name="confirm" class="small primary" @click.native="confirm()">
				{{ confirmText || $t('confirm') }}
			</ja-button>
			<ja-button name="cancel" class="small outlined" @click.native="cancel()">
				{{ cancelText || $t('cancel') }}
			</ja-button>
		</div>
	</ja-modal>
</template>

<script>
import Modal from '@/components/Modal/Modal';
import { CloseButton, Button } from '@ui';

export default {
	components: {
		jaModal: Modal,
		jaCloseButton: CloseButton,
		jaButton: Button
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: 'Confirmation'
		},
		cancelText: {
			type: String,
			default: ''
		},
		confirmText: {
			type: String,
			default: ''
		}
	},
	methods: {
		closeModal() {
			this.$emit('closeModal');
		},
		confirm() {
			this.$emit('confirm');
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>

<style lang="scss" scoped>
.heading-3 {
	margin-top: 0;
}
</style>
